/* eslint-disable @typescript-eslint/no-explicit-any */
import { createDecorator } from "vue-facing-decorator";
import _ from "lodash";

type functionName = (data: any, k?: string) => any;

export const Apollo = (options?: string | any, queryName?: string | functionName): any => {
    return createDecorator(
        (componentOptions, k) => {
            if (options) {
                // if (componentOptions.name === "Documents") {
                //     debugger
                // }
                let def_apollo: any = {
                    manual: true,
                    result({
                        data,
                        loading,
                        networkStatus,
                    }: {
                        data: any;
                        loading: any;
                        networkStatus: any;
                    }) {
                        if (!data) return;
                        const clonedData = _.cloneDeep(data);
                        // if ((componentOptions as any).apollo[k].specificResult) {
                        //     (componentOptions as any).apollo[k].specificResult({data:clonedData, loading, networkStatus})
                        // }
                        if (options.specificResult) {
                            if (componentOptions.name === "Documents") {
                                const data_ = componentOptions.data();
                                componentOptions.data = () => {
                                    return { ...data_, [k]: clonedData };
                                };
                            }
                            options.specificResult.call(
                                this,
                                { data: clonedData, loading, networkStatus },
                                k
                            );
                        } else if (queryName instanceof Function) {
                            this[k] = queryName.call(this, clonedData, k);
                        } else if (Array.isArray(clonedData[queryName || k])) {
                            this[k] = clonedData[queryName || k];
                        } else {
                            this[k] = Object.assign({}, clonedData[queryName || k]);
                        }
                    },
                };
                if (options.query) {
                    def_apollo = { ...def_apollo, ...options };
                } else {
                    def_apollo.query = options;
                }
                ((componentOptions as any).apollo ||
                    (((componentOptions as any).apollo = {}) as any))[k] = def_apollo;
            }
            /* else {
            ((componentOptions as any).apollo || ((componentOptions as any).apollo = {}) as any)[k] = componentOptions.methods[k];
            delete componentOptions.methods[k]
        } */
        },
        {
            preserve: true,
        }
    );
};

function getDeepValue(st: string, obj: any) {
    return st
        .replace(/\[([^\]]+)]/g, ".$1")
        .split(".")
        .reduce(function (o, p) {
            return o[p];
        }, obj);
}
type functionGetState = (state: any) => any;

export function State2Way(mutation: string, stateVariable?: string | functionGetState): any {
    return createDecorator((componentOptions, k) => {
        if (!componentOptions.computed) {
            componentOptions.computed = {};
        }

        componentOptions.computed[k] = {
            get() {
                if (typeof stateVariable === "string") {
                    return stateVariable
                        ? getDeepValue(stateVariable, (this as any).$store.state)
                        : (this as any).$store.state[k];
                } else if (stateVariable) {
                    return stateVariable((this as any).$store.state);
                }
            },
            set(val) {
                (this as any).$store.commit(mutation, val);
            },
        };
    });
}
